












import { Component, Vue } from "vue-property-decorator";
import { doctor as store } from "@/store/modules";

@Component({})
class DoctorSelector extends Vue {
  get items() {
    return Object.values(store.items);
  }
}

export default DoctorSelector;
